import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import 'antd/dist/antd.css';
import { useDispatch, useSelector } from 'react-redux';
import Popover from "@material-ui/core/Popover";
import loginImg from '../assets/jioLogo.png'
import { billChoice,getProductThemeData }  from "../store/actions/CommonAction";
import LocationIcon from '@material-ui/icons/LocationOn';
import { TimeoutLogic } from "../utils/TimeoutLogic";
import chooseBill from '../style.css/chooseBill.css';

const {  Content } = Layout;

const ChooseBill = (props) => {

const dispatch = useDispatch();
const selectedBill = useSelector(state => state.common.selectedBill)

const callAPI = async () => {
  try {
    
  } catch (error) {
    console.error(error)
  }
}


const openHome = async (bill) => {

  //alert("bill : "+bill);

  if(bill == "dpdp"){
    dispatch(billChoice('dpdp'));
    props.history.push("/home")
  }else if(bill == "gdpr"){
    dispatch(billChoice('gdpr'));
    props.history.push("/cookieConsent")
  }


}
const getTheme = async() =>{
  try {
    await dispatch(getProductThemeData())

  } catch (error) {
    console.error(error)
  }
}


    // eslint-disable-next-line
    useEffect(() => { 
      getTheme();
    }, [])



  return (
    <>
        <div className="lContainer-choose">

    <div class="cm-card text-center">
    <div className="d-flex align-items-center justify-content-center">
        <img  src={loginImg} alt="login" className="img-responsive p-1" style={{width: '60px',height: '60px'}} />
        <h6 style={{color: '#000', marginTop: '2%'}}>Consent Manager</h6>
    </div>
    <br></br>
    <h4>Choose your Business Geography/Jurisdiction</h4>
    
      <div class="row">
        <div class="col-sm-6">
          <div class="bill-card dpdp" onClick={(event)=> openHome('dpdp')}>
          
            <h4>INDIA</h4>
            <small>DPDP (Digital Personal Data Protection) Act</small>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="bill-card gdpr" onClick={(event)=> openHome('gdpr')}>
         
            <h4>EU</h4>
            <small>GDPR (General Data Protection Regulation)</small>
          </div>
        </div>
      </div>

    </div>
    <TimeoutLogic/>
  </div>

    </>
    );
}

export default ChooseBill;